/** @file Field check for one of a fixed list of literal values. */
import { failField } from '@zilo/pose3d-format/validate/fields/failField';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';

/** Check that `value` is one of `values` (compared with `===`). */
export function checkEnum(values: readonly (string | number | boolean)[]): FieldCheck {
  const expected = `one of ${values.map((v) => JSON.stringify(v)).join(', ')}`;
  return (value, path) => {
    if (!values.some((v) => v === value)) failField(path, expected, value);
  };
}
